import WorkspacePage from '../workspace/WorkspacePage';
import WorkspaceRouteBoundary, { WorkspaceLoading, WorkspaceOverlayLoading } from '../workspace/WorkspaceRouteBoundary';


import ResourceLibrary, { LegacyAcademyEntry } from '../components/utilities/ResourceLibrary';
import NewHire from '../components/onboarding/NewHire';
import NewHireSettings from '../components/onboarding/NewHireSettings';
import React, { useEffect, useMemo, useState } from 'react';
import { Redirect, Route, Switch, useLocation, withRouter } from 'react-router';





import Header from '../components/Header';



import NotFound from '../components/NotFound';







import { findSpecificSectionVideo } from '../helpers/global';
import { getDefaultRouteForUser } from '../helpers/roleHelpers';
import useKeypress from '../hooks/KeyPressHook';




const Admin = React.lazy(() => import('../components/admin'));
const CRM = React.lazy(() => import('../components/crm'));
const DocHub = React.lazy(() => import('../components/doc-hub/DocHub'));
const Installer = React.lazy(() => import('../components/installer/Installer'));
const Inventory = React.lazy(() => import('../components/inventory'));
const InventoryCleanup = React.lazy(() => import('../components/inventory-tools/InventoryCleanup'));
const Contract = React.lazy(() => import('../components/main'));
const Ops = React.lazy(() => import('../components/ops/Ops'));
const PipelineRoute = React.lazy(() => import('../components/pipeline'));
const Profile = React.lazy(() => import('../components/profile'));
const Reports = React.lazy(() => import('../components/reports/Reports'));
const Requests = React.lazy(() => import('../components/requests/Requests'));
const Schedule = React.lazy(() => import('../components/schedule/Schedule'));
const Utilities = React.lazy(() => import('../components/utilities/Utilities'));
const CourseTrainingIndex = React.lazy(() => import('../components/admin/courseTraining/CourseTrainingIndex'));
const ConversationBank = React.lazy(() => import('../components/conversation-bank'));
const TopProducerView = React.lazy(() => import('../components/top-producer/TopProducerView'));
const GlobalSearch = React.lazy(() => import('../components/globalSearch/index'));
const VideoPlayer = React.lazy(() => import('../components/common/VideoPlayer'));
const Messages = React.lazy(() => import('../components/messaging/Messages'));
const ServiceWorkOrders = React.lazy(() => import('../components/service-work-orders/ServiceWorkOrders'));

const Applications = React.lazy(() => import('../components/applications/Applications'));

const Home = ({ appChoices }) => {
  const location = useLocation();
  const [currentSectionVideoMeta, setCurrentSectionVideoMeta] = useState({});
  const [openVideoplayer, setOpenVideoPlayer] = useState(null);
  const [showGlobalSearch, setShowGlobalSearch] = useState(false);
  const [hasOpenedSearch, setHasOpenedSearch] = useState(false);
  const [globalSearchResults, setGlobalSearchResults] = useState(null);

  const onShowGlobalSearchValueChange = value => {
    setShowGlobalSearch(value);
    if (value) setHasOpenedSearch(true);
    if (value === false) {
      setGlobalSearchResults(null);
    }
  };
  const onOpenVideoPlayerChange = value => {
    setOpenVideoPlayer(value);
  };

  const onOpenVideoPlayerClose = () => {
    setOpenVideoPlayer(null);
  };

  const featuredVideoMeta = useMemo(() => {
    const videoUrls = appChoices
      ?.find(appChoice => appChoice.key === 'sectionVideos')
      ?.values?.find(videoData => videoData?.name === 'Featured Videos');

    return videoUrls;
  }, [location.pathname, appChoices]);

  useEffect(() => {
    const videoUrls = appChoices.find(appChoice => appChoice.key === 'sectionVideos');
    setCurrentSectionVideoMeta(findSpecificSectionVideo(videoUrls?.values, location.pathname));
  }, [location.pathname, appChoices]);

  // If two keys are clicked simultanously the first key must be [ctrl,alt,shift] key

  useKeypress(['ctrl', 'q'], () => {
    onShowGlobalSearchValueChange(true);
  });

  if (location.pathname === '/') {
    return <Redirect from="/" to={getDefaultRouteForUser()} />;
  }

  return (
    <>
      {hasOpenedSearch && <WorkspaceRouteBoundary active={showGlobalSearch} onClose={() => onShowGlobalSearchValueChange(false)}><React.Suspense fallback={showGlobalSearch ? <WorkspaceOverlayLoading label="Loading search" onClose={() => onShowGlobalSearchValueChange(false)} /> : null}><GlobalSearch
        onShowGlobalSearchValueChange={onShowGlobalSearchValueChange}
        showGlobalSearch={showGlobalSearch}
        globalSearchResults={globalSearchResults}
        onGlobalSearchResultsChange={setGlobalSearchResults}
      /></React.Suspense></WorkspaceRouteBoundary>}
 
      <Header
        currentSectionVideoMeta={currentSectionVideoMeta}
        featuredVideoMeta={featuredVideoMeta}
        onOpenVideoPlayerChange={onOpenVideoPlayerChange}
        onWorkspaceSearch={() => onShowGlobalSearchValueChange(true)}
      />

      {openVideoplayer && (
        <WorkspaceRouteBoundary onClose={onOpenVideoPlayerClose}><React.Suspense fallback={<WorkspaceOverlayLoading label="Loading video" onClose={onOpenVideoPlayerClose} />}><VideoPlayer
          videoLinks={openVideoplayer === 'section' ? currentSectionVideoMeta?.videoUrls : featuredVideoMeta?.videoUrls}
          title={openVideoplayer === 'section' ? currentSectionVideoMeta?.name : 'About This App'}
          onPlayerClose={onOpenVideoPlayerClose}
          openVideoplayer={openVideoplayer}
        /></React.Suspense></WorkspaceRouteBoundary>
      )}

      <main id="mhcw-main" className="mhcw-main" tabIndex={-1} style={{ paddingTop: 56 }}>
        <WorkspacePage><WorkspaceRouteBoundary key={location.pathname}><React.Suspense fallback={<WorkspaceLoading />}><Switch>
          <Route path="/messages"><Messages /></Route>
          <Route exact path="/onboarding/settings"><NewHireSettings /></Route>
          <Route exact path="/onboarding"><NewHire /></Route>
          <Route exact path="/profile">
            <Profile />
          </Route>
          <Route exact path="/service-work-orders"><ServiceWorkOrders /></Route>
          <Route exact path="/applications"><Applications /></Route>
          <Route path="/contract">
            <Contract />
          </Route>
          <Route path="/service-requests">
            <Requests />
          </Route>
          <Route path="/dochub">
            <DocHub />
          </Route>
          <Route path="/crm">
            <CRM />
          </Route>
          <Route exact path="/top-producer-view">
            <TopProducerView />
          </Route>
          <Route path="/conversation-bank">
            <ConversationBank />
          </Route>
          <Route exact path="/inventory/cleanup"><InventoryCleanup /></Route>
          <Route path="/inventory">
            <Inventory />
          </Route>
          <Route path="/walkthrough">
            <Ops />
          </Route>

          <Route path="/setup">
            <Installer />
          </Route>
          <Route path="/reports">
            <Reports />
          </Route>
          {/* View This */}
          <Route path="/schedule">
            <Schedule appChoices={appChoices} />
          </Route>
          <Route path="/pipeline">
            <PipelineRoute />
          </Route>
          <Route path="/utilities">
            <Utilities />
          </Route>
          <Route
            path="/mhc-sales-development-system/:courseId?"
            render={({ match, location }) => (
              <Redirect
                to={{
                  pathname: match.params.courseId
                    ? `/sales-academy/${match.params.courseId}`
                    : '/sales-academy',
                  search: location.search,
                  hash: location.hash
                }}
              />
            )}
          />
          <Route exact path="/sales-academy/:courseId">
            <CourseTrainingIndex />
          </Route>
          <Route exact path="/training-resources"><ResourceLibrary /></Route>
          <Route exact path="/sales-academy">
            <LegacyAcademyEntry />
          </Route>
          <Route path="/admin">
            <Admin />
          </Route>
          <Route path="*">
            <NotFound />
          </Route>
        </Switch></React.Suspense></WorkspaceRouteBoundary></WorkspacePage>
      </main>
    </>
  );
};

export default withRouter(Home);
